import { IconTriangleExclamation } from "@components/Icon/mod.ts";

export const iconExclamation = (
  <IconTriangleExclamation
    variant={"primary"}
    size={"l"}
  />
);
